var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('KeepAlive',[_c('div',{class:{ 'isDark': _vm.darkmode }},[(_vm.pauseDuration > 30)?_c('i',{staticClass:"fas fa-bed"}):(_vm.pauseDuration < 3)?_c('i',{staticClass:"fas fa-running"}):_c('i',{staticClass:"fas fa-male"})])])}
var staticRenderFns = []

export { render, staticRenderFns }